import React, { useState, useEffect, useContext } from "react";
import { Badge, Container, Button } from "react-bootstrap";
import MyLanding from "./MyLanding";
import Nav from "./Navbar";
import Footer from "./Footer";
const Blog = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <>
      <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
        {/* home */}

        <div>
          <Nav />
        </div>
        <div className="container p-0">
          <div className="mt-md-4">
            <div className="row  mx-md-0 mx-3 ">
              <div className="col-md-1 "></div>
              <div className="col-md-10 col-12 m-0 p-0">
                <div
                  className="row "
                  style={{ overflow: "hidden", height: "auto" }}
                >
                  <div className=" col-12 m-0 p-0 ">
                    <div className="" style={{ marginRight: "" }}>
                      <MyLanding />
                    </div>
                  </div>


                </div>
              </div>

              <div className="col-md-1"></div>
            </div>
          </div>
        </div>

        <div
          className="m-0 p-0"
          style={{
            overflow: "hidden",
            background: "#31393C",
            borderTopRightRadius: "2rem",
            borderTopLeftRadius: "2rem",
          }}
        >
          <Footer />
        </div>
      </Container>
    </>
  );
};

export default Blog;
